import { defineMessages } from "react-intl";

export const OFFER_BUILDER_MESSAGES = defineMessages({
  sectionHeading: { id: "offers v2 offer builder: section heading", defaultMessage: "FUNDING DETAILS" },
  fundingProvidedTitle: { id: "offers v2 offer builder: funding provided title", defaultMessage: "Funding provided" },
  fundingProvidedSubtext: {
    id: "offers v2 offer builder: funding provided subtext",
    defaultMessage: "This is how much funding Wayflyer will provide.",
  },
  remittanceAmountTitle: {
    id: "offers v2 offer builder: remittance amount title",
    defaultMessage: "Remittance amount",
  },
  percentageRemittanceAmountSubtext: {
    id: "offers v2 offer builder: percentage remittance amount subtext",
    defaultMessage: "You will remit a percentage of your sales to us.",
  },
  fixedRemittanceAmountSubtext: {
    id: "offers v2 offer builder: fixed remittance amount subtext",
    defaultMessage: "You will remit a fixed amount to us.",
  },
  costTitle: { id: "offers v2 offer builder: cost title", defaultMessage: "Cost" },
  costSubtext: {
    id: "offers v2 offer builder: cost subtext",
    defaultMessage:
      "This is the cost of your financing. It's calculated as a percentage of the total amount of funding we give you.",
  },
  totalRemittanceAmountTitle: {
    id: "offer v2 offer builder: total remittance amount title",
    defaultMessage: "Total remittance amount",
  },
  totalRemittanceAmountSubtext: {
    id: "offer v2 offer builder: total remittance amount subtext",
    defaultMessage:
      "This is the total amount that you will remit to Wayflyer under your contract. It's made up of the total funding provided plus the cost of financing.",
  },
});
